'use client';
import { useMediaQuery as useMediaQueryPrimitive } from 'react-responsive';

// N.B. These values are based on styles/breakpoints.scss
// If you change these, also update the breakpoints in the styles file
export default function useMediaQuery() {
  const breakpoint100 = useMediaQueryPrimitive({ query: `(max-width: 34em)` });
  const breakpoint200 = useMediaQueryPrimitive({ query: `(max-width: 48em)` });
  const breakpoint250 = useMediaQueryPrimitive({ query: `(max-width: 56em)` });
  const breakpoint300 = useMediaQueryPrimitive({ query: `(max-width: 64em)` });
  const breakpoint400 = useMediaQueryPrimitive({ query: `(max-width: 72em)` });
  const breakpoint450 = useMediaQueryPrimitive({ query: `(max-width: 80em)` });
  const breakpoint500 = useMediaQueryPrimitive({ query: `(max-width: 90em)` });

  return {
    breakpoint100,
    breakpoint200,
    breakpoint250,
    breakpoint300,
    breakpoint400,
    breakpoint450,
    breakpoint500
  };
}
